import { SYSTEM_NAME_ISBN } from './constants';

export const SYSTEM_NAME = SYSTEM_NAME_ISBN;

export const SYSTEM_FULL_NAME = SYSTEM_NAME_ISBN;

export const PRODUCTION_BUILD = false;

// Set to true to use HTTPS protocol for PROD build
export const PROD_BUILD_USE_HTTPS = false;

// Set to true when building for development server
export const DEVAPI_BUILD = true;

// Set to true to use HTTPS protocol for DEV build
export const DEV_BUILD_USE_HTTPS = true;

// Set to true when application's backend runs locally
export const LOCAL_BACKEND = false;

// Set to true when auth (front + back) runs locally
export const LOCAL_AUTH = false;

// Set to true when developing locally for local app redirection
export const LOCAL_DEVELOPMENT = false;

export const ALLOWED_ROLE_PREFIX = {
    'EPC': 'EPC',
    'ETD': 'ETD',
    'ISBN': 'ISBN',
    'ROOMBOOK': 'ROOMBOOK',
    'ZP': 'ZP',
    'UIK': 'UIK',
    'HELPDESK': 'HELPDESK',
    'TOOLS': 'TOOLS',
    'LIBADMIN': 'LIBADMIN',
    'AUTOPREVADZKA': 'AUTOPREVADZKA',
    'UK': 'UK'
};

export const ALLOWED_GENERAL_ROLES = [
    'SUPERADMIN',
    'PHD',
    'PEDAGOGUE',
    'EMPLOYEE'
];



// WEBPACK FOOTER //
// ./src/app/+app-custom/app.settings.ts